import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ignoreElements } from 'rxjs/operators';


@Injectable()
export class ErroLoggingService {

  constructor(private http: HttpClient) {
  }

  log(msg: ApplicationLog) {
  
    let url: string = "api/error/log/";
    return this.http.post<any>(url, msg).subscribe();
  }

}

export interface ApplicationLog {
  message: string;
  participantId: string;
  stack: string;
  url: string;
  participantCode: string;
  certificationId: string;
  referenceNumber:string
}


